module.exports = __webpack_public_path__ + "img/Mask Group 1.f882900a.svg";